import { AfterContentChecked, Component, OnInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisDynamicFieldBase } from '../../model/field-base';
import { HisDynamicFieldConfig } from '../../model/formfield';

import { HisUiService } from '../../../core/service/base/his-ui.service';
import { HisNotificationService } from '../../../core/service/notifications/his-notification.service';
import { HisBaseGlobalsService } from './../../../core/service/base/his-base-globals.service';
import { HisDynamicFieldConfigAndData } from '../../model/field-config-and-data';
import { GenericValue } from '../../../core/model/generic-value';
import { FormControl } from '@angular/forms';
import { AutoComplete, AutoCompleteSelectEvent } from 'primeng/autocomplete';

@Component({
    template: `
        <his-plam [label]="options.label" [helptext]="options.helptext">
          <p-autoComplete #content
            [hisDdKey]="options.ddKey"
            [formControl]="formControl"
            [hisEagerDataSource]="options.typeAheadUrl"
            [dropdown]="true"
            [forceSelection]="true"
            field="defaulttext"
            (onSelect)="onSelect($event)">
          </p-autoComplete>
        
          <p-dialog
            appendTo="body"
            showEffect="fade"
            [(visible)]="multiselectPopupVisible" [responsive]="true" [modal]="true" [dismissableMask]="true" [blockScroll]="true"
            (onHide)="hideMultiselectPopup()" [focusTrap]="true"
            [header]="('multiselectPlam.selectValues' | hisUi) + ' ' + options.label">
            <div class="floatLeft"></div>
            <div class="tableFilterEditBlock">
              @if (showTableFilter) {
                <span>
                  <button class="transparent hideOnMobile" (click)="toggleFilter(); $event.preventDefault();"
                    hisImage="FILTER">
                    <span>
                      {{(toggleTableFilter) ? ('de.his.faces.tags.table.tableFilter.disable' | hisUi) :
                      ('de.his.faces.tags.table.tableFilter.enable' | hisUi)}}
                    </span>
                  </button>
                </span>
              }
            </div>
            <div class="clearerSpaceAboveHalfEm"></div>
            <p-table #selectTable
              [value]="filteredCustomOptions"
              [paginator]="true"
              [selectionPageOnly]="true"
              [rows]="pageSize"
              [(first)]="firstResultRow"
              [(selection)]="selectedRows"
              (onPage)="onPage($event); selectTable?.el?.nativeElement?.scrollIntoView(({block: 'start', behavior: 'smooth'}));">
              <ng-template pTemplate="header">
                <tr>
                  <th class="multiSelectColumn">
                    <p-tableHeaderCheckbox class="hideOnBreakpointSmall"
                      title="{{'genericSearch.selectAllOfPage' | hisUi}}">
                    </p-tableHeaderCheckbox>
                    <span class="hideOnBreakpointLarge">{{'genericSearch.rowselect' | hisUi}}</span>
                  </th>
                  <th [pSortableColumn]="'label'">
                    {{options.label}}
                    @if (toggleTableFilter) {
                      <div>
                        <input #content [title]="'genericSearch.resultTable.tableFilter.applyFilter' | hisUi"
                          pInputText type="text" [formControl]="filter"
                          (keydown.enter)="$event.stopPropagation(); onFilterTable()"
                          (click)="$event.stopPropagation();"/>
                      </div>
                    }
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr>
                  <td class="multiSelectColumn">
                    <p-tableCheckbox (click)="$event.preventDefault();"
                      [value]="row" title="{{'genericSearch.selectItems' | hisUi}}"
                      tabindex="0" ariaLabel="{{'genericSearch.selectItems' | hisUi}}">
                    </p-tableCheckbox>
                  </td>
                  <td>{{row.defaulttext}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="paginatorright">
                <div  class="tableRowCount">
                  <span>
                    {{'de.his.faces.tags.table.datascroller.numRowsFound.label' | hisUi}}
                    {{i18nKeyForRecords | hisUi: totalRowCount}} | 
                    @if (totalNumberOfPages > 1) {
                      {{'de.his.faces.tags.table.datascroller.numRowsFound.page'
                      | hisUi: currentPageNumber: totalNumberOfPages }} |
                    }
                    <label for="tableRow">
                      @if (maxRows) {
                        <span>
                          {{'de.his.faces.tags.table.datascroller.numRowsPerPage' | hisUi}} (Max:{{maxRows}})
                        </span>
                      }
                    </label>
                    <input #content [formControl]="maxTableRows" required class="input_3_Chars tableRowInput"
                      (keydown.enter)="$event.stopPropagation(); calculateTotalNumberOfPages()"
                      (click)="$event.stopPropagation();">
                  </span>
                </div>
              </ng-template>
            </p-table>
            <ng-template #footer>
              <button type="submit" iconPos="left" hisImage="TICK" class="button_highlighted marginRightStandard"
                (click)="submitSelection(); hideMultiselectPopup(); $event.preventDefault();">
                <span style="vertical-align: middle">{{'genericSearch.returnSelected' | hisUi}}</span>
              </button>
              <button type="submit" iconPos="left" hisImage="RED_X" class="button_highlighted blue"
                (click)="hideMultiselectPopup(); $event.preventDefault();">
                <span style="vertical-align: middle">{{'genericSearch.backToParentSearch' | hisUi}}</span>
              </button>
            </ng-template>
          </p-dialog>
        
          @if (!options.customOptionsMethod) {
            <ng-container class="selectedOptionsList">
              @if (selectedOptions && selectedOptions.length > 0) {
                <p-dataView #content
                  [hisDdKey]="options.ddKey" [formControl]="formControl"
                  [value]="selectedOptions" [emptyMessage]="'&nbsp;'">
                  <ng-template let-selectedOptions #list>
                    <div class="p-grid p-grid-nogutter">
                      <ul>
                        @for (selectedOption of selectedOptions; track selectedOption; let index = $index) {
                          <li class="selectedDataRow">
                            {{selectedOption.defaulttext}}
                            @if (!options.disabled) {
                              <button type="submit"
                                (click)="deleteSelectedOption(index)"
                                hisImage="PANEL_CLOSE" class="icon deleteSelectedOption"
                                title="{{'common.removeAssignmentOf' | hisUi:selectedOption.defaulttext}}">
                              </button>
                            }
                          </li>
                        }
                      </ul>
                    </div>
                  </ng-template>
                </p-dataView>
              }
            </ng-container>
          }
          @if (options.customOptionsMethod) {
            <ng-container class="selectedOptionsListWithSelection">
              @if (selectedOptions && selectedOptions.length > 0) {
                <p-dataView #content
                  [hisDdKey]="options.ddKey" [formControl]="formControl" styleClass="selectedDataContainer"
                  [value]="selectedOptions" [emptyMessage]="'&nbsp;'">
                  <ng-template let-selectedOptions #list>
                    <div class="p-grid p-grid-nogutter">
                      <ul>
                        @for (selectedOption of selectedOptions; track selectedOption; let index = $index) {
                          <li class="selectedDataRow">
                            {{selectedOption.defaulttext}}
                            @if (!options.disabled) {
                              <button type="submit"
                                (click)="$event.stopPropagation(); deleteSelectedOption(index);"
                                hisImage="PANEL_CLOSE" class="icon deleteSelectedOption"
                              title="{{selectedOption.label}}: {{'view.controls.disconnect' | hisUi}}"></button>
                            }
                          </li>
                        }
                      </ul>
                    </div>
                  </ng-template>
                </p-dataView>
              }
            </ng-container>
          }
        
          @if (options.customOptionsMethod) {
            <button #inputElement
              type="submit" [disabled]="options.disabled"
              class="transparent selectButton" hisImage="ARROW_RIGHT_FAT" alt=""
              (click)="showMultiselectPopup(); $event.preventDefault();">
              <span>
                {{(selectedOptions?.length > 0) ? ('genericSearch.changeSelectedItems' | hisUi) : ('genericSearch.selectItems' | hisUi)}}
              </span>
            </button>
          }
          @if (options.customOptionsMethod && selectedOptions && selectedOptions.length > 0) {
            <button type="submit"
              class="transparent selectButton" hisImage="PANEL_CLOSE" alt=""
              (click)="deleteAllSelectedOptions(); $event.preventDefault();">
              <span>{{'genericSearch.deleteSelectedItems' | hisUi}}</span>
            </button>
          }
        </his-plam>
        `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KeytableMultiSelectComponent extends HisDynamicFieldBase<string> implements OnInit, AfterContentChecked {
    private notificationService = inject(HisNotificationService);
    private uiService = inject(HisUiService);

    @ViewChild( 'content' ) autoComplete: AutoComplete;
    pageSize = 10;
    maxRows = 300;
    currentPageNumber = 1;
    totalNumberOfPages?: number;
    maxTableRows = new FormControl(this.pageSize);
    firstResultRow = 0;

    genericValueTypes: GenericValue[];
    options: HisDynamicFieldConfig;
    selectedOptions: GenericValue[] = [];
    selectedRows: GenericValue[] = [];

    multiselectPopupVisible = false;

    filter = new FormControl('');
    toggleTableFilter = true;
    showTableFilter = true;

    filteredCustomOptions: GenericValue[] = [];

    constructor() {
        const injectedData = inject<HisDynamicFieldConfigAndData>('injectedData' as any);
        const hbgs = inject(HisBaseGlobalsService);

        super(injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs);
        this.options = injectedData.options;
        if (this.options.customOptions) {
            this.filteredCustomOptions = this.options.customOptions;
        }
    }
    
    get i18nKeyForRecords() {
        return 'de.his.faces.tags.table.datascroller.numRowsFound' + ( this.totalRowCount === 1 ? '.record' : '.records' );
    }
    
    get totalRowCount() {
        return this.filteredCustomOptions.length;
    }
    
    ngOnInit() {
        super.initFormControl(this.value);
        this.deleteAllSelectedOptions();
    }

    ngAfterContentChecked() {
        if( ( this.autoComplete && this.autoComplete._suggestions ) && this.genericValueTypes == null ) {
            if( this.autoComplete._suggestions ) {
                this.genericValueTypes = this.autoComplete._suggestions();
                this.setSelectedOptions(this.options.defaultValue);
            }
        }
    }

    onSelect(event: AutoCompleteSelectEvent) {
        let selectedElement = event.value as GenericValue;
        this.addSelectedElement(selectedElement);
    }

    addSelectedElement( selectedElement: GenericValue ) {
        if ( this.selectedOptions.find( selectedOption => selectedOption.id === selectedElement.id ) ) {
            this.notificationService.info(
                this.uiService.translate( 'genericSearch.alreadySelected', selectedElement.defaulttext ), 'Info' );
        } else {
            this.selectedOptions = [...this.selectedOptions, selectedElement];
        }
        this.formControl.setValue(this.selectedOptions.map(o => o.id).join(','), { emitEvent: false });
        this.autoComplete.inputEL.nativeElement.value = '';
    }

    deleteSelectedOption(index: number) {
        this.selectedOptions.splice(index, 1);
        this.selectedOptions = [...this.selectedOptions];
        if ( this.selectedOptions.length === 0 ) {
            this.autoComplete.clear();  
        }
    }

    deleteAllSelectedOptions() {
        this.selectedOptions = [];
        this.selectedRows = [];
        this.formControl.setValue(this.selectedOptions, {emitEvent: false});
    }

    updateConfiguration(entireFormConfig: HisDynamicFieldConfig) {
        this.selectedOptions = [];
        let matchingConfig = this.searchFieldConfig(entireFormConfig);
        if (matchingConfig !== null) {
            if (this.genericValueTypes) {
                this.setSelectedOptions(matchingConfig.defaultValue);
            }
        }
    }

    reset() {
        if (this.formGroup) {
            this.formControl.reset(this.defaultValue);
            this.selectedOptions = [...this.defaultValue];
        }
    }

    private setSelectedOptions(defaultValue: string) {
        if(defaultValue != null && defaultValue !== undefined) {
            defaultValue.split(',').forEach((value: string) => {
                if ( this.genericValueTypes ) {
                    this.genericValueTypes.find(( genericValue: GenericValue) => {
                        if (genericValue.id === Number.parseFloat(value)) {
                            this.selectedOptions.push(genericValue);
                        }
                    });
                }
            });
        }
    }

    getControlValue(): any {
        return this.selectedOptions.map(selectedOption => selectedOption.id).join();
    }

    showMultiselectPopup() {
        this.selectedRows = (this.selectedOptions) ? this.selectedOptions.slice(0) : [];
        for(let selectedRow of this.selectedRows){
            for(let element of this.filteredCustomOptions){
                if(element.id === selectedRow.id){
                    this.filteredCustomOptions.splice(this.filteredCustomOptions.indexOf(element), 1, selectedRow);
                }
            }
        }
        this.calculateTotalNumberOfPages();
        this.multiselectPopupVisible = !this.multiselectPopupVisible;
    }

    hideMultiselectPopup() {
        this.multiselectPopupVisible = false;
    }

    submitSelection() {
        this.selectedOptions = [];
        for (let row of this.selectedRows) {
            this.addSelectedElement(row);
        }
    }

    toggleFilter() {
        this.toggleTableFilter = !this.toggleTableFilter;

        if (!this.toggleTableFilter) {
            this.filter.setValue('');
            this.onFilterTable();
        }
    }

    onFilterTable() {
        if (this.filter.value) {
            this.filteredCustomOptions = [];
            for (let element of this.options.customOptions) {
                if (element.defaulttext?.toUpperCase().indexOf(this.filter.value.toUpperCase()) > -1) {
                    this.filteredCustomOptions = [...this.filteredCustomOptions, element];
                }
            }
            this.calculateTotalNumberOfPages();
        }
        else{
            this.filteredCustomOptions = this.options.customOptions;
            this.calculateTotalNumberOfPages();
        }
    }

    calculateTotalNumberOfPages(){
        if(this.maxTableRows && this.maxTableRows.value > 0 || this.maxTableRows.value > this.maxRows) {
            this.pageSize = +this.maxTableRows.value;
        }
        this.maxTableRows.setValue(this.pageSize);
        this.totalNumberOfPages = Math.ceil(this.filteredCustomOptions.length / this.pageSize);
    }

    onPage(event: any) {
        this.pageSize = +this.maxTableRows.value;
        this.firstResultRow = event.first;
        this.currentPageNumber = 1 + this.firstResultRow / this.pageSize;
    }
}
